import { Select, Option } from 'element-ui'
import {
  createDateRangePickerOptions,
  formatDateValue,
  getMonthDateRange,
  getMonthOptions
} from '@/utils/dateRange'

export default function withMonthSidebar(panel) {
  return {
    extends: panel,
    data() {
      return { monthShortcuts: createDateRangePickerOptions().shortcuts }
    },
    computed: {
      selectedMonth() {
        if (!this.minDate || !this.maxDate || this.rangeState.selecting) return ''
        const month = formatDateValue(this.minDate).slice(0, 7)
        const [start, end] = getMonthDateRange(month)
        return formatDateValue(this.minDate) === formatDateValue(start) &&
          formatDateValue(this.maxDate) === formatDateValue(end) ? month : ''
      },
      monthOptions() {
        const options = getMonthOptions()
        const month = this.selectedMonth
        if (month && !options.some(option => option.value === month)) {
          options.push({ value: month, label: `${month.slice(0, 4)}年${month.slice(5)}月` })
          options.sort((a, b) => b.value.localeCompare(a.value))
        }
        return options
      }
    },
    methods: {
      pickMonth(month) {
        this.$emit('pick', getMonthDateRange(month))
      }
    },
    render(h) {
      // Element creates the calendar separately, so its sidebar slot belongs to the panel.
      this.$slots.sidebar = [
        h('div', { class: 'el-picker-panel__sidebar screen-date-range-sidebar' }, [
          h(Select, {
            class: 'screen-date-range-month',
            props: {
              value: this.selectedMonth,
              placeholder: '快捷选月',
              size: 'mini',
              filterable: true,
              popperAppendToBody: false,
              popperClass: 'screen-month-options'
            },
            attrs: { 'aria-label': '快捷选择月份' },
            on: { change: this.pickMonth }
          }, this.monthOptions.map(option => h(Option, {
            key: option.value,
            props: option
          }))),
          h('div', { class: 'screen-date-range-shortcuts' }, this.monthShortcuts.map(shortcut => h('button', {
            key: shortcut.text,
            class: 'el-picker-panel__shortcut',
            attrs: { type: 'button' },
            on: { click: () => this.handleShortcutClick(shortcut) }
          }, shortcut.text)))
        ])
      ]
      return panel.render.call(this, h)
    }
  }
}
